import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ShareIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M2 14h12a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2ZM7 3.414 3.707 6.707a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L9 3.414V11a1 1 0 1 1-2 0V3.414Z", fill: "currentColor" })));
});
ShareIcon.displayName = 'ShareIcon';
export default ShareIcon;
